import {Component, OnInit, OnDestroy, ViewChild, AfterViewInit, EventEmitter, HostListener, ChangeDetectorRef} from '@angular/core';
import {Router, ActivatedRoute, NavigationStart} from '@angular/router';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {Section, State} from '../model/eform-type';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import {EFormHelper} from '../helper/script/helper';
import {SelectorHelper} from '../helper/script/selector';
import {EformService} from '../service/eform.service';
import {TestValueService} from '../service/testvalue.service';
import {EformAPI} from '../e-form.api';
import {MessageBoxComponent} from '../../shared/message-box/message-box';
import {Toast} from '../../shared/toast/toast';
import {MomentPipe} from 'app/shared/moment.pipe';
import {DateTime} from '../helper/pipe/datetime.pipe';
import {TranslateService} from '@ngx-translate/core';
import {MatLegacyMenuTrigger as MatMenuTrigger} from '@angular/material/legacy-menu';
import {ContextMenuHelper} from '../helper/script/context-menu';
import {cloneControl} from '../helper/script/cloneAbstract';
import {FormGenerateComponent} from '../form-generate/form-generate.component';
import {fromEvent, merge, Observable, Subject, Subscription, timer} from 'rxjs';
import {IdleStateService} from '../service/idle-state.service';
import {FormTranslateComponent} from '../dialog/form-translate/form-translate.component';
import {FormGroup} from '@angular/forms';
import {MatDrawer} from '@angular/material/sidenav';
import {debounce, map} from 'rxjs/operators';
import {HelperTransalaterService} from '../service/helper-translate.service';
import { DynamicFormBuilderComponent } from '../form-generate/dynamic-form-builder/dynamic-form-builder.component';
import { IdexService } from 'app/idex.service';

@Component({
   selector: 'app-form-create',
   templateUrl: './form-create.component.html',
   styleUrls: ['./form-create.component.scss']
})
export class FormCreateComponent implements OnInit, OnDestroy, AfterViewInit {
   state: State = {name: 'f-control', sectionIndex: -1, fieldIndex: -1, tableIndex: -1, nameTable: ''};
   @ViewChild('drawer') public drawer: MatDrawer;
   @ViewChild(DynamicFormBuilderComponent) dynamicForm: DynamicFormBuilderComponent;
   eventsState: Subject<void> = new Subject<void>();
   dragStartIndex: number;
   dragFieldData: { sectionIndex: number, fieldIndex: number, key: string } = null;
   dragTableColumnData: { sectionIndex: number, fieldIndex: number, tableIndex: number, key: string } = null;
   saveInProgress = false;
   subscription: Subscription;
   selector = new SelectorHelper();
   formType: string;
   lang: string;
   activeFocus = true;
   expand = true;
   itemSelections: any;
   helper = new EFormHelper();
   canEdit = false;
   checkDefault = {set: '', obj: []};
   dictionary: Promise<Object>;
   translateService: Subscription;
   keyEvents: Subscription;
   @ViewChild(MatMenuTrigger) contextMenu: MatMenuTrigger;
   clickEvents: EventEmitter<string> = new EventEmitter<string>();
   contexts: ContextMenuHelper;
   checkFormName: boolean;
   checkFileName: boolean;
   checkSpecialCharacter: boolean;
   formName: string;
   formNameValue: string;
   isEdit:boolean
   tin: string;
   public sections: Section[];
   loading: boolean = true;
   isDefaultChange: boolean = false;
   closeBtn: string;
   cancelBtn: string;
   saveBtn: string;
   lastModified: string;
   fileNameLabel: string;
   noLabel: string;
   existing: string;
   formNameBtn: string
   docId: string;
   isViewOnly: boolean = false;
   isOpenFile: boolean = false;
   filename: string;
   coporateUserRole: string;
   isStartFlow: boolean = false;

   constructor(public service: EformService, private testValue: TestValueService, private api: EformAPI, private router: Router, private cdr: ChangeDetectorRef,
               private toast: Toast, private dialog: MatDialog, public translate: TranslateService, private route: ActivatedRoute,
               private idleState: IdleStateService, private helperTranslater: HelperTransalaterService, private idexService: IdexService) {
      this.contexts = new ContextMenuHelper(this.contextMenu, this.service);
      if (localStorage.getItem('form-type') === 'dms') {
         this.formType = 'NF';
      } else if (localStorage.getItem('form-type') === 'view') {
         this.formType = 'VF';
      } else if (localStorage.getItem('form-type') === 'form') {
         this.formType = 'FM';
      } else {
         this.formType = 'TP';
      }
      if (localStorage.getItem('isOpenFile') === 'true') {
         this.isOpenFile = true;
         localStorage.removeItem('isOpenFile');
      } else {
         this.idleState.active();
      }
   }

   ngOnInit(): void {
      this.service.initailization();
      this.route.paramMap.subscribe(paramMap => {
         this.coporateUserRole = history.state.coporateRole;
         if (history.state.docStatus) {
            this.isViewOnly = true;
         }
         if (paramMap.get('type') !== null) {
            const data = localStorage.getItem('form-view');
            this.getEFormByObject(JSON.parse(data));
         } else if (paramMap.get('formId') !== null) {
            this.getEForm(paramMap.get('formId'));
         } else if(paramMap.get('docId') !== null) {
            this.docId = paramMap.get('docId');
            this.idexService.getDocument(this.docId).subscribe((o) => {
               this.filename = o.name;
               this.isStartFlow = o.startFlow;
               if (!o.permissions.edit) {
                  this.isViewOnly = true;
               }
               this.cdr.detectChanges();
            });
            this.getEFormByDocId(this.docId);
         } else {
            this.lang = this.translate.currentLang;
            this.initialDictionary(this.translate.currentLang);
         }
      });
      this.tin = localStorage.getItem('tin');
      this.setLanguage();
   }

   ngAfterViewInit(): void {
      this.contexts = new ContextMenuHelper(this.contextMenu, this.service);
      this.filterFormName();
      this.keyEvents = this.bindKeypressEvent().subscribe(($event: KeyboardEvent) => {
         const _conditions = this.itemSelections !== undefined && this.itemSelections?.type !== undefined && this.itemSelections?.type !== null;
         if (_conditions) {
            this.onKeyPress($event);
         }
      });
      this.dynamicForm?.detectChanges();
      setTimeout(()=>{
         this.service.eForm.reset(this.service.eForm.value);
         this.service.eForm.markAllAsTouched();
      }, 600);
   }

   ngOnDestroy(): void {
      this.service.unInitailization();
      this.keyEvents.unsubscribe();
      this.service.isNotCompleteAllSign = false;
      if (this.isOpenFile) {
         localStorage.removeItem('form-view');
         localStorage.removeItem('isOpenFile');
      } else {
         this.idleState.deActive();
      }
   }

   initialDictionary(origin) {
      this.translate.getTranslation(origin).subscribe((translation) => {
         this.dictionary = translation['eform'];
      });
   }

   getPropertiesDictionary(type: string, label: string) {
      return this.dictionary !== undefined ? this.dictionary['field-properties'][type][label] : '';
   }

   getEForm(formId) {
      this.saveInProgress = true;
      const _transformDate = new MomentPipe();

      this.api.getEFormFormDocId(formId).subscribe((res) => {
         const setValueService = (res) => {
            if (this.formType !== 'NF') {
               this.lang = res.body.data.original;
            } else {
               this.lang = this.translate.currentLang;
            }
            if (this.formType === 'VF') {
               if (res.body.fileName) {
                  this.formNameValue = res.body.fileName.replace(/\.zdox$/, '');
               }
            }
            this.service.eForm.controls.original.setValue(this.lang);
            this.initialDictionary(this.lang);
            this.service.formValue.id = res.body.formId;
            this.service.formValue.original = this.lang;
            this.service.formValue.lastUpdate = {when: _transformDate.transform(res.body.lastUpdate)};
            this.service.formValue.version = res.body.version;

            this.service.storeMetaField(res.body.data.formName, res.body.data.key);
            this.service.storeSection(res.body.data.sections);
            this.service.storeValue(res.body.data.value ?  JSON.parse(res.body.data.value) : '');
            this.setFormName(res.body.data);
            this.sections = this.service.eForm.value.sections;
            this.loading = false;
            if (this.lastModified) {
               this.lastModified = this.lastModified.replace('{{when}}', this.service.formValue.lastUpdate.when);
            }
         }

         if (res.statusCodeValue === 200) {
            setValueService(res);
         } else {
            this.api.getEForm(formId).subscribe((res) => {
               if (res.statusCodeValue === 200) {
                  setValueService(res);
               } else {
                  this.translate.get('eform.errors.form-not-found').subscribe((s) => {
                     this.toast.error(s);
                     setTimeout(() => {
                        this.router.navigate([this.getBack()]);
                     },1000);
                  })
               }
            })
         }
      }, (err) => {
         console.error(err);
      }, () => {
         this.saveInProgress = false;
      });
   }

   getEFormByDocId(docId) {
      this.saveInProgress = true;
      const _transformDate = new MomentPipe();
      const filename = localStorage.getItem('filename');
      this.api.getEFormFormDocId(docId).subscribe((res) => {
         if (this.formType !== 'NF') {
            this.lang = res.body.data.original;
         } else {
            this.lang = this.translate.currentLang;
         }
         if (this.formType === 'VF') {
            this.formNameValue = filename.replace(/\.zdox$/, '');
         }
         this.service.eForm.controls.original.setValue(this.lang);
         this.initialDictionary(this.lang);
         this.service.formValue.id = res.body.formId;
         this.service.formValue.original = this.lang;
         this.service.formValue.lastUpdate = {when: _transformDate.transform(res.body.lastUpdate)};
         this.service.formValue.version = res.body.version;

         this.service.storeMetaField(res.body.data.formName, res.body.data.key);
         this.service.storeSection(res.body.data.sections);
         this.service.storeValue(res.body.data.value ?  JSON.parse(res.body.data.value) : '');
         this.setFormName(res.body.data);
         this.sections = this.service.eForm.value.sections;
         this.loading = false;
         if (this.lastModified) {
            this.lastModified = this.lastModified.replace('{{when}}', this.service.formValue.lastUpdate.when);
         }
         let isSignCount = 0;
         let _signatureSignedForm = [];
         let resFormValue = res.body.data.value ?  JSON.parse(res.body.data.value) : '';
         for (const section of res.body.data.sections) {
            _signatureSignedForm = [..._signatureSignedForm, ...section.fields.filter(field => field.fieldType === 'f-signature')];
         }
         if (_signatureSignedForm.length) {
            for (const form of _signatureSignedForm) {
               if (resFormValue[form.fieldName] !== '') {
                  form.isSign = true;
                  isSignCount++;
               } else {
                  form.isSign = false;
               }
            }
         }
         if (isSignCount > 0 && isSignCount <= _signatureSignedForm.length) {
            this.service.isNotCompleteAllSign = true;
         }
      }, (err) => {
         console.error(err);
      }, () => {
         this.saveInProgress = false;
      });
   }

   getEFormByObject(form: any): void {
      this.isViewOnly = true;
      this.filename = localStorage.getItem('filename');
      this.formNameValue = this.filename?.replace(/\.zdox$/, '');
      this.lang = localStorage.getItem('lang') || 'en';
      setTimeout(() => {
         this.service.eForm.controls.original.setValue(form.original);
         this.initialDictionary(this.lang);
         this.service.formValue.original = this.lang;
         this.service.storeMetaField(form.formName, form.key);
         this.service.storeSection(form.sections);
         this.service.storeValue(form.value ? JSON.parse(form.value) : '');
         this.setFormName(form);
         this.formNameValue = this.formName;
         this.sections = this.service.eForm.value.sections;
         this.loading = false;
      },250);
   }

   onStateChange(_state: string, $event: any, sectionIndex?: number, fieldIndex?: number, context?: boolean, items?: any, tableIndex?: number): void {
      this.service.eForm.markAllAsTouched();
      this.contexts._closeContext();
      this.itemSelections = {event: $event, sectionIndex: sectionIndex, fieldIndex: fieldIndex, type: _state, obj: items, tableIndex: tableIndex};
      switch (_state) {
         case 'section':
            this.state.name = 'f-section';
            this.state.sectionIndex = sectionIndex;
            this.selector.hightLight(sectionIndex);
            break;
         case 'field':
            this.state.name = this.onStateGetFieldType(sectionIndex, fieldIndex);
            this.state.sectionIndex = sectionIndex;
            this.state.fieldIndex = fieldIndex;
            if ($event || $event === undefined) {
               this.selector.hightLight(sectionIndex, fieldIndex, $event);
               this.testValue.clearValue();
            }
            break;
         case 'new-field':
            this.state.name = 'f-control';
            this.state.sectionIndex = sectionIndex;
            this.selector.hightLight(sectionIndex, -1, $event);
            break;
         case 'new-section':
            this.state.name = 'f-control-new-section';
            this.state.sectionIndex = -1;
            this.selector.hightLight(-1, -1, $event);
            break;
         case 'new-table':
            this.state.name = 'f-control-table';
            this.state.sectionIndex = sectionIndex;
            this.state.fieldIndex = fieldIndex;
            this.selector.hightLight(sectionIndex, fieldIndex, $event, -1);
            break;
         case 'f-control-table':
            this.state.name = 'f-control-table';
            this.state.sectionIndex = sectionIndex;
            this.state.fieldIndex = fieldIndex;
            this.selector.hightLight(sectionIndex, fieldIndex, $event, -1);
            break;
         case 'field-table':
            if (context) {
               this.contexts.onContextMenu($event, items, _state, sectionIndex, fieldIndex, tableIndex);
            }
            this.state.name = 'table';
            this.state.sectionIndex = sectionIndex;
            this.state.fieldIndex = fieldIndex;
            this.state.tableIndex = tableIndex;

            this.state.nameTable = this.onStateGetFieldTableType(sectionIndex, fieldIndex, tableIndex);
            if ($event || $event === undefined) {
               this.selector.hightLight(sectionIndex, fieldIndex, $event, tableIndex);
               this.testValue.clearValue();
            }
            break;

         default:
            this.state.name = 'f-control';
            this.selector.clearSelector();
            break;
      }
      this.clickEvents.emit(this.state.name);
      this.eventsState.next();
   }

   onStateGetFieldType(sectionIndex: number, fieldIndex: number): string {
      const result = this.helper.getFieldValue(this.service.eForm, sectionIndex, fieldIndex);
      return result?.fieldType ? result.fieldType : 'f-control';
   }

   onStateGetFieldTableType(sectionIndex: number, fieldIndex: number, tableIndex: number): string {
      const result = this.helper.getFieldTableValue(this.service.eForm, sectionIndex, fieldIndex, tableIndex);
      return result?.fieldType ? result.fieldType : 'f-control';
   }

   onKeyDown($event: any): void {
    this.checkFormName = false;
    if ($event.key === 'Enter' || $event.key === 'Escape') {
        this.canEdit = false;
    }
    if (['*', '|', '\\', '/', ':', '"', '<', '>', '?'].includes($event.key)) {
      this.checkSpecialCharacter = true;
      this.checkFormName = false;
    } else {
      this.checkSpecialCharacter = false;
    }
   }

   onKeyUpFileName(fileName) {
      let checkCharacters = /[<>\\/:?*"|]/g;
      this.checkFileName = false;
      if (fileName.trim() !== '') {
         this.checkFileName = checkCharacters.test(fileName.trim());
      }
   }

   checkFormNameFn() {
      const formName = this.service.eForm.controls['formName'].value;
      return formName.th || formName.en || formName.cn;
   }

   onKeyUp(formName) {
      const specialChars = ['|', '\\', '/', ':', '"', '<', '>', '?', '*'];
      this.checkFormName = false;
      if (formName !== this.formName && formName.trim() !== '' && this.tin) {
         this.api.checkedFormNameAll(formName, this.tin, this.formType).subscribe(data => {
            let nameArray = data.content.map(item => item.formName);
            this.checkFormName = nameArray.includes(formName);
            if (formName === '#') {
               this.checkFormName = false;
               this.checkSpecialCharacter = false;
            }
         });
         // ตรวจสอบว่ามีตัวอักษรพิเศษอยู่ใน formName หรือไม่
         this.checkSpecialCharacter = formName.split('').some(char => specialChars.includes(char));
      }
   }

   onClick($event: any) {
      this.canEdit = true;
      setTimeout(() => {
         $event.target.focus();
      }, 0);
   }

   filterFormName() {
      const _formName = this.service.eForm.controls.formName as FormGroup;
      const _lampUp = this.translate.currentLang;
      _formName.get(_lampUp).valueChanges.subscribe(res => {
         if (res.match(/^\s+$/g)) {
            _formName.get(this.lang).setErrors({noSpace: true});
         }
      });
      this.chainFilterFormName(_formName, _lampUp);
   }

   chainFilterFormName(_formName: FormGroup, _lampUp: string) {
      const _originalChange = this.service.eForm.controls.original as FormGroup;
      _originalChange.valueChanges.subscribe((v: string) => {
         if (v !== _lampUp) {
            _formName.get(v).valueChanges.subscribe((res: string) => {
               if (res.match(/^\s+$/g)) {
                  _formName.get(this.lang).setErrors({noSpace: true});
               }
            });
         }
      });
   }

   addController(control: string, $event?: any, index?: number) {
      const _tmpGroup = new FormGroup({});
      const _obj = {fieldIndex: -1, sectionIndex: -1, tableIndex: null, type: '', items: _tmpGroup};
      switch (control) {
         case 'f-section':
            this.service.createSection(index);
            _obj.sectionIndex = (index || index === 0) ? index : this.helper.getSectionAsFormArray(this.service.eForm).length - 1;
            _obj.type = 'section';
            _obj.items = this.helper.getSectionAsFormGroupWithIndex(this.service.eForm, _obj.sectionIndex);
            this.service.eForm.markAsDirty();
            break;
         default:
            const field = this.service.createFields(this.state.sectionIndex, -1, '', control);
            if (field) {
               _obj.type = 'field';
               _obj.fieldIndex = field.length - 1;
               _obj.sectionIndex = this.state.sectionIndex;
               _obj.items = this.helper.getFieldAsFormGroupWithIndex(this.service.eForm, _obj.sectionIndex, _obj.fieldIndex);
               this.service.eForm.markAsDirty();
            }
            break;
      }
      this.onStateChange(_obj.type, $event, _obj.sectionIndex, _obj.fieldIndex, false, _obj.items, _obj.tableIndex);
      if (control === 'f-section') {
         setTimeout(() => {
            focusFunc('control-section-input-name');
         }, 150);
      }
   }

   addControllerTable(control: string, $event?: any, index?: number) {
      const _tmpGroup = new FormGroup({});
      const _obj = {fieldIndex: -1, sectionIndex: -1, tableIndex: -1, type: '', items: _tmpGroup};
      const field = this.service.createFieldsTable(this.state.sectionIndex, this.state.fieldIndex, -1, '', control);
      _obj.type = 'field-table';
      _obj.fieldIndex = this.state.fieldIndex;
      _obj.sectionIndex = this.state.sectionIndex;
      _obj.tableIndex = field.length - 1;
      _obj.items = this.helper.getFieldTableAsFormGroupWithIndex(this.service.eForm, _obj.sectionIndex, _obj.fieldIndex, _obj.tableIndex);
      this.service.eForm.markAsDirty();

      this.onStateChange(_obj.type, $event, _obj.sectionIndex, _obj.fieldIndex, false, _obj.items, _obj.tableIndex);
   }

   dropSection($event: CdkDragDrop<any>, _firstIndex?: boolean) {
      if (!$event.isPointerOverContainer) {
         return;
      }
      if ($event.container.id === $event.previousContainer.id) {
         moveItemInArray($event.container.data, $event.previousIndex, $event.currentIndex);
         this.onStateChange('section', '', $event.currentIndex);
      } else if ($event.item.data.id === 'f-section') {
         _firstIndex ? this.addController($event.item.data.id, '') :
            this.addController($event.item.data.id, '',
               $event.currentIndex !== 0 ? $event.currentIndex - 1 : 0);
      }
      this.contexts._finishCut();
      this.service.eForm.markAsDirty();
      this.helper.getSectionAsFormArray(this.service.eForm).updateValueAndValidity();
   }

   dropFieldControl($event: CdkDragDrop<any>, sectionIndex: number) {
      const draggedFieldKey = this.dragFieldData?.key;
      const selectDraggedField = (targetSectionIndex: number, fallbackIndex: number) => {
         const selectedIndex = draggedFieldKey ? this.findFieldIndexByKey(targetSectionIndex, draggedFieldKey) : fallbackIndex;
         const resolvedIndex = selectedIndex >= 0 ? selectedIndex : fallbackIndex;

         this.selector.hightLightDragDrop(targetSectionIndex, resolvedIndex);
         setTimeout(() => {
            this.onStateChange('field', false, targetSectionIndex, resolvedIndex);
         }, 0);
      };

      if (!$event.isPointerOverContainer) {
         return;
      }
      if ($event.container.id.startsWith('fieldTable-') || $event.container.id.startsWith('new-table-')) {
         return;
      }
      // If dragging a table column to another table field
      if ($event.item.data && $event.item.data.type === 'table-column') {
         const targetField = this.helper.getFieldValue(this.service.eForm, sectionIndex, $event.container.data.index);
         if (targetField && targetField.fieldType === 'f-table') {
            // Move column from one table to another
            const sourceColumns = this.helper.getFieldTableAsFormArray(this.service.eForm,
               this.dragTableColumnData.sectionIndex, this.dragTableColumnData.fieldIndex);
            const targetColumns = this.helper.getFieldTableAsFormArray(this.service.eForm, sectionIndex, $event.container.data.index);
            const columnControl = sourceColumns.at(this.dragTableColumnData.tableIndex);
            sourceColumns.removeAt(this.dragTableColumnData.tableIndex);
            targetColumns.push(columnControl);
            this.service.eForm.markAsDirty();
            this.dragTableColumnData = null;
            this.dragFieldData = null;
            return;
         }
         // Dragging table column to a regular section - convert to field and copy data
         const sourceColumns = this.helper.getFieldTableAsFormArray(this.service.eForm,
            this.dragTableColumnData.sectionIndex, this.dragTableColumnData.fieldIndex);
         const sourceColumnControl = sourceColumns.at(this.dragTableColumnData.tableIndex) as FormGroup;
         const clonedControl = cloneControl(sourceColumnControl);

         // Convert field type from t-* to f-*
         let fieldType = clonedControl.get('fieldType').value;
         if (fieldType && fieldType.startsWith('t-')) {
            fieldType = 'f-' + fieldType.substring(2);
            clonedControl.get('fieldType').setValue(fieldType);
         }

         // Remove column from source table
         sourceColumns.removeAt(this.dragTableColumnData.tableIndex);

         // Insert cloned control into target section
         const targetFields = this.helper.getFieldAsFormArray(this.service.eForm, sectionIndex);
         const insertIndex = $event.container.data.index !== undefined ? $event.container.data.index : targetFields.length;
         if (insertIndex >= 0 && insertIndex < targetFields.length) {
            targetFields.insert(insertIndex, clonedControl);
         } else {
            targetFields.push(clonedControl);
         }
         targetFields.updateValueAndValidity();
         this.service.eForm.markAsDirty();
         this.dragTableColumnData = null;
         this.dragFieldData = null;
         return;
      }
      // If dropping a new control onto an existing f-table field, add as table column
      if ($event.item.data && $event.container.data.index !== undefined) {
         const targetField = this.helper.getFieldValue(this.service.eForm, sectionIndex, $event.container.data.index);
         if (targetField && targetField.fieldType === 'f-table') {
            let fieldType = $event.item.data.id;
            if (fieldType.startsWith('f-')) {
               fieldType = 't-' + fieldType.substring(2);
            }
            this.service.createFieldsTable(sectionIndex, $event.container.data.index, -1, '', fieldType);
            this.service.eForm.markAsDirty();
            this.dragFieldData = null;
            return;
         }
      }
      // If dragging an existing field from section onto a f-table field, convert to table column and copy data
      if (!$event.item.data && $event.container.data.index !== undefined) {
         const targetFieldIndex = $event.container.data.index;
         const sourceFieldIndex = $event.previousContainer.data.index;
         const targetField = this.helper.getFieldValue(this.service.eForm, sectionIndex, targetFieldIndex);
         if (targetField && targetField.fieldType === 'f-table') {
            // Get the source field control
            const sourceFieldControl = this.helper.getFieldAsFormGroupWithIndex(this.service.eForm, this.dragStartIndex, sourceFieldIndex);
            if (sourceFieldControl && sourceFieldControl.get('fieldType').value !== 'f-table') {
               // Clone the source field
               const clonedControl = cloneControl(sourceFieldControl);

               // Convert field type from f-* to t-*
               let fieldType = clonedControl.get('fieldType').value;
               if (fieldType && fieldType.startsWith('f-')) {
                  fieldType = 't-' + fieldType.substring(2);
                  clonedControl.get('fieldType').setValue(fieldType);
               }

               // Calculate the adjusted target index after removing source field
               let adjustedTargetIndex = targetFieldIndex;
               if (this.dragStartIndex === sectionIndex && sourceFieldIndex < targetFieldIndex) {
                  adjustedTargetIndex = targetFieldIndex - 1;
               }

               // Remove field from source section
               this.helper.getFieldAsFormArray(this.service.eForm, this.dragStartIndex).removeAt(sourceFieldIndex);
               this.helper.getFieldAsFormArray(this.service.eForm, this.dragStartIndex).updateValueAndValidity();

               // Insert cloned control into target table columns
               const targetColumns = this.helper.getFieldTableAsFormArray(this.service.eForm, sectionIndex, adjustedTargetIndex);
               targetColumns.push(clonedControl);
               targetColumns.updateValueAndValidity();
               this.service.eForm.markAsDirty();
               this.dragFieldData = null;
               return;
            }
         }
      }
      if (compareIds($event)) {
         moveItemInArray(this.helper.getFieldAsFormArray(this.service.eForm, sectionIndex).controls,
            $event.previousContainer.data.index, $event.container.data.index);
         this.helper.getFieldAsFormArray(this.service.eForm, sectionIndex).updateValueAndValidity();
      } else if ($event.item.data) {
         this.service.createFields(sectionIndex, $event.container.data.index, '', $event.item.data.id);
         setTimeout(() => {
            focusFunc('field-labelName');
         }, 200);
      } else {
         transferArrayItem(this.helper.getFieldAsFormArray(this.service.eForm, this.dragStartIndex).controls,
            this.helper.getFieldAsFormArray(this.service.eForm, sectionIndex).controls,
            $event.previousContainer.data.index,
            $event.container.data.index === undefined ? $event.container.data.length : $event.container.data.index);
         this.helper.getFieldAsFormArray(this.service.eForm, this.dragStartIndex).updateValueAndValidity();
         this.helper.getFieldAsFormArray(this.service.eForm, sectionIndex).updateValueAndValidity();
      }
      const _currentIndex = $event.container.data.index === undefined ? $event.container.data.length - 1 : $event.container.data.index;
      selectDraggedField(sectionIndex, _currentIndex);
      this.service.eForm.markAsDirty();
      this.contexts._finishCut();
      this.dragFieldData = null;
   }

   dragStarted(sectionIndex: number, fieldIndex?: number, fieldKey?: string) {
      this.dragStartIndex = sectionIndex;
      this.dragFieldData = (fieldIndex !== undefined && fieldKey)
         ? { sectionIndex, fieldIndex, key: fieldKey }
         : null;
      this.contexts._closeContext();
   }

   dragTableColumnStarted(sectionIndex: number, fieldIndex: number, tableIndex: number) {
      const columnKey = this.helper.getFieldTableAsFormArray(this.service.eForm, sectionIndex, fieldIndex)
         ?.at(tableIndex)?.value?.key;

      this.dragTableColumnData = { sectionIndex, fieldIndex, tableIndex, key: columnKey };
      this.contexts._closeContext();
   }

   canEnterFieldDropList = (drag: any, drop: any): boolean => {
      const isTableColumn = drag?.data?.type === 'table-column';
      const isTableField = drop?.data?.item?.fieldType === 'f-table';

      if (isTableColumn && isTableField) {
         return false;
      }

      return true;
   }

   canEnterSectionDropList = (drag: any, drop: any): boolean => {
      const isTableColumn = drag?.data?.type === 'table-column';
      const dropId = drop?.id as string | undefined;
      const sourceSectionId = isTableColumn ? `section-${drag?.data?.sectionIndex}` : null;

      if (isTableColumn && dropId === sourceSectionId) {
         return false;
      }

      return true;
   }

   dropTableControl($event: CdkDragDrop<any>, sectionIndex: number, fieldIndex: number) {
      const draggedColumnKey = this.dragTableColumnData?.key;
      const selectDraggedTableColumn = (targetSectionIndex: number, targetFieldIndex: number, fallbackIndex: number) => {
         const selectedIndex = draggedColumnKey
            ? this.findTableColumnIndexByKey(targetSectionIndex, targetFieldIndex, draggedColumnKey)
            : fallbackIndex;
         const resolvedIndex = selectedIndex >= 0 ? selectedIndex : fallbackIndex;

         this.selector.hightLightDragDrop(targetSectionIndex, targetFieldIndex, resolvedIndex);
         setTimeout(() => {
            this.onStateChange('field-table', false, targetSectionIndex, targetFieldIndex, false, undefined, resolvedIndex);
         }, 0);
      };

      if (!$event.isPointerOverContainer) {
         return;
      }

      const targetColumns = this.helper.getFieldTableAsFormArray(this.service.eForm, sectionIndex, fieldIndex);

      // Reorder or transfer an existing table column.
      if ($event.item.data && $event.item.data.type === 'table-column' && this.dragTableColumnData) {
         const sourceColumns = this.helper.getFieldTableAsFormArray(this.service.eForm,
            this.dragTableColumnData.sectionIndex, this.dragTableColumnData.fieldIndex);

         if (this.dragTableColumnData.sectionIndex === sectionIndex &&
             this.dragTableColumnData.fieldIndex === fieldIndex) {
            if ($event.previousIndex !== $event.currentIndex) {
               const columnControl = sourceColumns.at($event.previousIndex);
               sourceColumns.removeAt($event.previousIndex);
               sourceColumns.insert($event.currentIndex, columnControl);
               sourceColumns.updateValueAndValidity();
            }
         } else {
            const sourceIndex = this.dragTableColumnData.tableIndex;
            const columnControl = sourceColumns.at(sourceIndex);
            sourceColumns.removeAt(sourceIndex);
            targetColumns.insert($event.currentIndex, columnControl);
            targetColumns.updateValueAndValidity();
            sourceColumns.updateValueAndValidity();
         }

         selectDraggedTableColumn(sectionIndex, fieldIndex, $event.currentIndex);
         this.service.eForm.markAsDirty();
         this.dragTableColumnData = null;
         return;
      }

      // Drop a new control from the sidebar into the table.
      if ($event.item.data && $event.item.data.id) {
         let fieldType = $event.item.data.id;
         if (fieldType.startsWith('f-')) {
            fieldType = 't-' + fieldType.substring(2);
         }
         this.service.createFieldsTable(sectionIndex, fieldIndex, $event.currentIndex, '', fieldType);
         this.service.eForm.markAsDirty();
         return;
      }

      // Convert an existing section field into a table column.
      const sourceFieldIndex = $event.previousContainer?.data?.index;
      const sourceFieldControl = this.helper.getFieldAsFormGroupWithIndex(this.service.eForm, this.dragStartIndex, sourceFieldIndex);

      if (sourceFieldControl && sourceFieldControl.get('fieldType').value !== 'f-table') {
         const clonedControl = cloneControl(sourceFieldControl);
         let fieldType = clonedControl.get('fieldType').value;

         if (fieldType && fieldType.startsWith('f-')) {
            fieldType = 't-' + fieldType.substring(2);
            clonedControl.get('fieldType').setValue(fieldType);
         }

         this.helper.getFieldAsFormArray(this.service.eForm, this.dragStartIndex).removeAt(sourceFieldIndex);
         this.helper.getFieldAsFormArray(this.service.eForm, this.dragStartIndex).updateValueAndValidity();
         targetColumns.insert($event.currentIndex, clonedControl);
         targetColumns.updateValueAndValidity();
         this.service.eForm.markAsDirty();
      }
   }

   private getTableColumnOrder(sectionIndex: number, fieldIndex: number): string[] {
      const columns = this.helper.getFieldTableAsFormArray(this.service.eForm, sectionIndex, fieldIndex);
      if (!columns) {
         return [];
      }

      return columns.controls.map((control, index) => {
         const value = control.value;
         const label = value?.labelName?.[this.service.formValue.original]
            || value?.fieldName
            || value?.fieldType
            || `index-${index}`;

         return `${index}:${label}:${value?.key}`;
      });
   }

   private findTableColumnIndexByKey(sectionIndex: number, fieldIndex: number, columnKey: string): number {
      const columns = this.helper.getFieldTableAsFormArray(this.service.eForm, sectionIndex, fieldIndex);
      return columns?.controls.findIndex(control => control?.value?.key === columnKey) ?? -1;
   }

   private findFieldIndexByKey(sectionIndex: number, fieldKey: string): number {
      const fields = this.helper.getFieldAsFormArray(this.service.eForm, sectionIndex);
      return fields?.controls.findIndex(control => control?.value?.key === fieldKey) ?? -1;
   }

   private getFieldOrder(sectionIndex: number): string[] {
      const fields = this.helper.getFieldAsFormArray(this.service.eForm, sectionIndex);
      if (!fields) {
         return [];
      }

      return fields.controls.map((control, index) => {
         const value = control?.value;
         const label = value?.labelName?.[this.service.formValue.original]
            || value?.fieldName
            || value?.fieldType
            || `index-${index}`;

         return `${index}:${label}:${value?.key}`;
      });
   }

   submitEForm(actions: string, options?: boolean) {
      this.saveInProgress = true;
      const formId = this.service.formValue.id ?? 0;
      const formInfo = {
         form: this.service.eForm.value,
         tin: localStorage.getItem('siteCode'),
         formType: this.formType,
         path: localStorage.getItem('form-path'),
         fileName: this.filename
      };
      if (actions === 'publish' || actions === 'draft') {
         let tempFormValue = this.service.eForm.value;
         tempFormValue.value = '';
         formInfo.form = tempFormValue;
      }
      if (formInfo.form.value && typeof formInfo.form.value === 'object') {
         formInfo.form.value = JSON.stringify(formInfo.form.value);
      }
      this.api.submitEForm(actions, formId, formInfo, this.docId).subscribe((res) => {
            this.toast.success(res.message);
            if (actions === 'publish' || options) {
               this._close('');
            } else if (actions === 'new-form' || actions === 'view-form' || options) {
               this.saveInProgress = false;
               this.router.navigate([this.getBack()]);
            } else {
               const _transformDate = new MomentPipe();
               this.service.formValue.id = res.formId;
               this.service.formValue.lastUpdate = {when: _transformDate.transform(res.lastUpdate)};
               this.service.formValue.version = res.version;
               this.service.eForm.markAllAsTouched();
               this.setFormName(this.service.eForm.value);
               this.isDefaultChange = false;
               this.translate.get('viewer.last_modified', {when:this.service.formValue.lastUpdate.when}).subscribe((s) => {
                  this.lastModified = s;
               });
            }
            this.isEdit = false;
         }, (err) => {
            this.saveInProgress = false;
            if (err.status === 400) {
               this.translate.get('eform.submit.error').subscribe((msg) => {
                  this.toast.error(msg);
               });
            } else {
               this.toast.error(err.message);
            }
         },
         () => {
            this.saveInProgress = false;
            this.service.eForm.reset(this.service.eForm.value);
            this.service.eForm.markAllAsTouched();
         });
   }

   cancel(val?: string): void {
      const data = {
         message: this.helperTranslater.getTagEform('msg.aware-cancel-save'),
         ok: {
            color: 'primary',
            label: this.helperTranslater.getSingleTranslation('create_tasks.save'),
            action: () => {
               this._ok()
               return true;
            }
         },
         close: {
            label: this.helperTranslater.getTagEform('button.dont-save'),
            action: () => this._close(val)
         }
      };
      if (this.formType === 'NF' || this.formType === 'VF') {
         if (val === 'b') {
            const _dialog = this.dialog.open(MessageBoxComponent, {disableClose: true, data});
            _dialog.afterOpened().subscribe(() => {});
            _dialog.afterClosed().subscribe(() => {});
         } else {
            this._close(val);
         }
      } else if (this.service.eForm.dirty && !this.service.eForm.controls.formName.invalid && !this.checkFormName) {
         const _dialog = this.dialog.open(MessageBoxComponent, {disableClose: true, data});
         _dialog.afterOpened().subscribe(() => this.activeFocus = false);
         _dialog.afterClosed().subscribe(() => this.activeFocus = true);
      } else {
         this._close(val);
      }
   }

   getBack(): string {
      let route = localStorage.getItem('form-type');
      if (route === 'dms' || route === 'view') {
         route = decodeURIComponent(localStorage.getItem('callback-url'));
      } else if (route === 'form') {
         route = '/eform/list/form/open';
      } else {
         route = '/eform/list/template/open';
      }
      return route;
   }

   canPublish(): boolean {
      return this.helper.getSectionAsFormGroupWithIndex(this.service.eForm, 0)?.get('fields').value.length > 0;
   }

   _ok() {
      if (this.formType === 'NF') {
         if (this.service.eForm.dirty && !this.service.eForm.controls.formName.invalid) {
            this.onSubmit()
         } else {
            this.translate.get('eform.submit.error').subscribe((msg) => {
               this.toast.error(msg);
            });
         }
      } else if (this.formType === 'VF') {
         this.onSubmit()
      } else {
         this.submitEForm('draft', true);
      }
      return true;
   }

   _close(val: string) {
      let route = localStorage.getItem('form-type');
      if (localStorage.getItem('form-type') === 'dms' || localStorage.getItem('form-type') === 'view') {
         this.router.navigate([decodeURIComponent(localStorage.getItem('callback-url'))]);
      } else {
         if (val === 'b') {
            route === 'form' ? route = '/eform/list/form/back' : route = '/eform/list/template/back';
         } else {
            route === 'form' ? route = '/eform/list/form/cancel' : route = '/eform/list/template/cancel';
         }
         this.router.navigate([route]);
      }
   }

   hookContext($event: MouseEvent, item: any, type: string, sectionIndex?: number, fieldIndex?: number) {
      const target = $event.target as HTMLElement;

      const isNewTable = item.fieldType === 'f-table' && target.classList.contains('new-field') && target.classList.contains('field') && target.classList.contains('new-table') || (item.fieldType === 'f-table' && target.classList.contains('field-set'));
      const isNewElementType = type === 'new-section' || type === 'new-field' || isNewTable;
      const hasNoCopyData = !this.contexts._hasDataCopy();
      const isNewSectionType = type === 'new-section';

      $event.preventDefault();
      $event.stopPropagation();

      const shouldNotShowMenu = isNewElementType && (hasNoCopyData || isNewSectionType);

      if (shouldNotShowMenu) {
         return false;
      }

      this.onStateChange(type, $event, sectionIndex, fieldIndex, true);
      this.contexts.onContextMenu($event, item, type, sectionIndex, fieldIndex);
   }

   hookEventContextDelete(item: any) {
      this.contexts.$eventDelete(item);
      this.service.eForm.markAsDirty();
      this.onStateChange(null, null);
   }

   hookEventContextPaste($event: MouseEvent, item: any) {
      const _tmpGroup = new FormGroup({});
      this.contexts.$eventPaste(item);
      const _obj = {fieldIndex: null, sectionIndex: null, tableIndex: null, type: '', items: _tmpGroup};
      if (item.type === 'section' || item.type === 'new-section') {
         const section = this.helper.getSectionAsFormArray(this.service.eForm);
         _obj.type = 'section';
         _obj.sectionIndex = (item.type === 'new-section') ? section.length - 1 : this.contexts.isCut ?
            this.contexts.cutUpperIndex(item.sectionIndex, 'section') : item.sectionIndex + 1;
         _obj.items = this.helper.getSectionAsFormGroupWithIndex(this.service.eForm, _obj.sectionIndex);
      } else if (item.type === 'field-table' || item.type === 'new-table' || item.type === 'f-control-table') {
         const tableColumns = this.helper.getFieldTableAsFormArray(this.service.eForm, item.sectionIndex, item.fieldIndex);
         _obj.type = 'field-table';
         _obj.sectionIndex = item.sectionIndex;
         _obj.fieldIndex = item.fieldIndex;
         _obj.tableIndex = (item.type === 'new-table' || item.type === 'f-control-table') ? tableColumns.length - 1 : this.contexts.isCut ?
            this.contexts.cutUpperIndex(item.fieldIndex, 'field-table', item.sectionIndex, item.tableIndex) : item.tableIndex + 1;
         _obj.items = this.helper.getFieldTableAsFormGroupWithIndex(this.service.eForm, _obj.sectionIndex, _obj.fieldIndex, _obj.tableIndex);
      } else {
         const field = this.helper.getFieldAsFormArray(this.service.eForm, item.sectionIndex);
         _obj.type = 'field';
         _obj.sectionIndex = item.sectionIndex;
         _obj.fieldIndex = (item.type === 'new-field') ? field.length - 1 : this.contexts.isCut ?
            this.contexts.cutUpperIndex(item.fieldIndex, 'field', item.sectionIndex) : item.fieldIndex + 1;
         _obj.items = this.helper.getFieldAsFormGroupWithIndex(this.service.eForm, _obj.sectionIndex, _obj.fieldIndex);
      }
      this.onStateChange(_obj.type, $event, _obj.sectionIndex, _obj.fieldIndex, false, _obj.items, _obj.tableIndex);
      this.contexts._finishCut();
      this.getValidationErrors();
   }

   getValidationErrors() {
      const length = this.service.eForm.controls.sections.value.length;
      let checkArr = [];
      for(let sectionIndex=0;sectionIndex<length;sectionIndex++){
         let arr = this.helper.getFieldAsFormArray(this.service.eForm, sectionIndex);
         checkArr = [...checkArr,...arr.controls];
      }
      if (checkArr.length > 1) {
         for(let c of checkArr) {
            const filterArr = checkArr.filter(item => item.value.fieldName === c.value.fieldName);
            if (filterArr.length > 1) {
               c.markAsDirty();
               c.markAsTouched();
               c.setErrors({'existing': true});
            }
         }
      }
   }

   onKeyPress($event: KeyboardEvent) {
      const _cannotCopy = this.itemSelections.type === 'new-section' || this.itemSelections.type === 'new-field' || this.itemSelections.type === 'new-table';
      const _compareType = this.itemSelections.type.replace('new-', '');
      const _isTableType = (type: string) => type === 'field-table' || type === 'table' || type === 'f-control-table' || type === 'new-table';
      const _typesMatch = () => {
         if (_compareType === this.contexts.typeCopy) return true;
         // Allow pasting field-table to any table context
         if ((this.contexts.typeCopy === 'field-table' || this.contexts.typeCopy === 'field') && (_isTableType(_compareType) || _compareType === 'field')) return true;
         return false;
      };
      if (($event.ctrlKey || $event.metaKey) && $event.code === 'KeyC') {
         if (!_cannotCopy && this.activeFocus) {
            this.contexts.$eventCopy(this.itemSelections);
         }
      }

      if (($event.ctrlKey || $event.metaKey) && $event.code === 'KeyX') {
         this.itemSelections.fieldIndex = this.itemSelections.fieldIndex === -1 || this.itemSelections.fieldIndex === null
            ? undefined : this.itemSelections.fieldIndex;
         if (!_cannotCopy && this.activeFocus) {
            this.contexts.$eventCut(this.itemSelections);
         }
      }

      if (($event.ctrlKey || $event.metaKey) && $event.code === 'KeyV') {
         if (this.contexts.isCopy || this.contexts.isCut) {
            if (_typesMatch() && this.activeFocus) {
               this.hookEventContextPaste(this.itemSelections.event, this.itemSelections);
               if (this.itemSelections.type === 'field' || this.itemSelections.type === 'new-field') {
                  this.selector.hightLightDragDrop(this.itemSelections.sectionIndex, this.itemSelections.fieldIndex);
               } else if (this.itemSelections.type === 'field-table' || this.itemSelections.type === 'new-table') {
                  this.selector.hightLight(this.itemSelections.sectionIndex, this.itemSelections.fieldIndex, null, this.itemSelections.tableIndex);
               }
            }
         }
      }

      if (($event.ctrlKey || $event.metaKey) && $event.code === 'KeyZ') {
         if (this.contexts.isCopy || this.contexts.isCut && this.activeFocus) {
            this.contexts.isCopy = false;
            this.contexts.isCut = false;
         }
      }

      if ($event.code === 'Delete') {
         if (!_cannotCopy && this.activeFocus) {
            this.hookEventContextDelete(this.itemSelections);
         }
      }
   }

   private bindKeypressEvent(): Observable<KeyboardEvent> {
      const eventsType$ = [
         fromEvent(window, 'keypress'),
         fromEvent(window, 'keydown')
      ];

      return merge(...eventsType$)
         .pipe(
            debounce(() => timer(10)),
            map(state => (state as KeyboardEvent))
         );
   }

   openPreview() {
      const formInfo = this.service.eForm.value;
      const dialogRef = this.dialog.open(FormGenerateComponent, {
         disableClose: true,
         data: {
            formId: '',
            formInfo: formInfo
         },
         panelClass: 'my-dialog',
         width: 'auto',
         height: 'auto',
         minWidth: '520px',
      });

      dialogRef.componentInstance.isPreview = true;

      dialogRef.afterOpened().subscribe(() => this.activeFocus = false);

      dialogRef.afterClosed().subscribe(result => {
         this.activeFocus = true;
         if (result) {
            this.translate.get('eform.submit.success').subscribe(s => {
               this.toast.success(s);
            });
         }
      });
   }

   openTranslate() {
      const _dialog = this.dialog.open(FormTranslateComponent,
         {
            data: {eForm: this.service.eForm},
            disableClose: true
         });
      _dialog.afterOpened().subscribe(() => this.activeFocus = false);
      _dialog.afterClosed().subscribe(result => {
         this.isEdit = result;
         this.activeFocus = true
      });
   }

   placeholderHandle(placeholder: string, data: any, type?: string): string {

      const _dateTimePipe = new DateTime();
      let _placeholder = '';
      if (data.fieldType === 'f-currency' || data.fieldType === 't-currency') {
         _placeholder = placeholder;
      } else if (data.fieldType !== 'f-phone' && data.fieldType !== 't-phone' && data.fieldType !== 'f-table' && data?.placeholder?.[this.lang]) {
         _placeholder = this.displayWithLang(data.placeholder);
      } else {
         switch (data.type) {
            case 'single_line':
               _placeholder = 'Single Line';
               break;
            case 'multi_line':
               _placeholder = 'Multiple Line';
               break;
            case 'password':
               _placeholder = 'Password';
               break;
            case 'integer':
               _placeholder = 'Integer';
               break;
            case 'decimal':
               _placeholder = 'Decimal';
               break;
            case 'percent':
               _placeholder = 'Percent';
               break;
            case 'email':
               _placeholder = 'example@email.com';
               break;
            case 'website':
               _placeholder = 'http://www.abc.com';
               break;
            case 'landline_type1':
               _placeholder = 'xx-xxx-xxxx';
               break;
            case 'landline_type2':
               _placeholder = '+xx xx-xxx-xxxx';
               break;
            case 'landline_type3':
               _placeholder = 'xxx-xxx-xxx';
               break;
            case 'mobile':
               _placeholder = 'xxx-xxx-xxxx';
               break;
            case data.type :
               _placeholder = _dateTimePipe.transform(type, data);
               break;
            default:
               break;
         }
      }
      return _placeholder;
   }

   /**
    * Track fields by their stable control key so selection/highlight moves with the
    * dragged control instead of staying bound to the old array index.
    */
   trackChangeByIndex(index: number, item: { key?: string }) {
      return item?.key ?? index;
   }

   displayWithLang(label: { [language: string]: string; }) {
      let _value: string;
      for (const [lang, value] of Object.entries(label)) {
         if (lang === this.service.formValue.original) {
            _value = value;
         }
      }
      return _value;
   }

   fullLabelLang(keyword: string) {
      let _text: string;
      const _curLang = this.service.eForm.controls.original.value;
      this.translate.get(keyword).subscribe(v => {
         _text = v.length !== undefined ? v : v[_curLang];
      });
      return _text;
   }

   callLang() {
      return this.service.eForm.controls.original.value;
   }

   setFocusKeyPress(v) {
      if (v && this.sections && this.sections.length > 0) {
         this.isDefaultValueChange(this.sections[0].fields, this.service.eForm.value.sections[0].fields)
      }
      this.activeFocus = v;
   }

   setDefaultValue(type: any, defaultValue?: any, optionValue?: any, object?: any, index?) {
      let _value;
      const _faultSelection = () => {
         this.checkDefault.set = this.checkDefault.set === '' ? optionValue : this.checkDefault.set;
         if (this.checkDefault.set !== optionValue) {
            this.checkDefault.set = optionValue;
            this.checkDefault.obj = [];
         }
         if (this.checkDefault.obj.findIndex(v => v === index) === -1 && defaultValue?.toString() === optionValue?.toString()) {
            this.checkDefault.obj.push(index);
         }
         return index === this.checkDefault.obj[0];
      };
      const _compareChoiceLabel = () => {
         for (const _obj of object) {
            if (_obj.value === defaultValue.toString()) {
               _value = _obj.label[this.service.formValue.original];
               break;
            } else if (_obj.isPrompt && _obj.value === defaultValue.toString()) {
               _value = _obj.label[this.service.formValue.original];
               break;
            } else {
               _value = '';
            }
         }

      };
      switch (type) {
         case 'select-choice' :
            _compareChoiceLabel();
            break;
         default :
            _value = _faultSelection();
            break;
      }
      return _value;
   }

   radioTranslate(choice: number, indexString: number) {
      let _text = '';
      switch (choice) {
         case 0:
            _text = this.getPropertiesDictionary('radio', 'yes-no');
            break;
         case 1:
            _text = this.getPropertiesDictionary('radio', 'true-false');
            break;
         case 2:
            _text = this.getPropertiesDictionary('radio', 'enable-disable');
            break;
         case 3:
            _text = this.getPropertiesDictionary('radio', 'on-off');
            break;
         case 4:
            _text = this.getPropertiesDictionary('radio', 'read-unread');
            break;
         default:
            break;
      }
      const x = _text.split('/');
      return indexString === 0 ? x[0] : x[1];
   }


   displayWithlimitation(items: Array<any>, type?: string) {
      let _result;
      switch (type) {
         case 'master' :
            _result = items.filter((item, index) => index < 10 && !item.isPrompt);
            break;
         default :
            _result = items.filter((item) => !item.isPrompt);
            break;
      }
      return _result;
   }

   checkFieldTable(fieldsTable) {
      for (const index in fieldsTable) {
         if ((fieldsTable[index].fieldType === 't-number' || fieldsTable[index].fieldType === 't-currency') && fieldsTable[index].typeSummary !== 'none') {
            return true;
         }
      }
      return false;

   }

   setFormName(data:any){
      if (this.formType === 'NF') {
         const _formName = this.service.eForm.controls.formName as FormGroup;
         _formName.controls[this.lang].setValue('');
         this.formName = '';
      } else {
         switch(this.lang) {
            case 'th': {
               this.formName =  data.formName.th;
               break;
            }
            case 'cn': {
               this.formName =  data.formName.cn;
               break;
            }
            default: {
               this.formName =  data.formName.en;
            }
         }
      }
   }

   onSubmit() {
      if (this.service.isNotCompleteAllSign) {
         this.dynamicForm.enableAllFields();
      }
      this.dynamicForm.onSubmit();
   }

   onCheckSubmit(event: any) {
      if (event) {
         switch (this.formType) {
            case 'NF':
               this.submitEForm('new-form');
               break;
            case 'VF':
               this.submitEForm('view-form');
               break;
            default:
               break;
         }
      }
   }

   isDefaultValueChange(defaultValue: any, newValue: any) {
      defaultValue.map(async (v, i) => {
         if (v.fieldType === 'f-choice') {
            if(v.choiceDefaultValue !== newValue[i].choiceDefaultValue) this.isDefaultChange = true ;
         }
      })
   }
   setLanguage() {
      this.translate.get('close').subscribe((s) => {
         this.closeBtn = s;
      });
      this.translate.get('cancel').subscribe((s) => {
         this.cancelBtn = s;
      });
      this.translate.get('save').subscribe((s) => {
         this.saveBtn = s;
      });
      this.translate.get('viewer.last_modified').subscribe((s) => {
         this.lastModified = s;
      });
      this.translate.get('form-list.header.form-name').subscribe((s) => {
         this.fileNameLabel = s;
      });
      this.translate.get('eform.errors.no-label-formName').subscribe((s) => {
         this.noLabel = s;
      });
      this.translate.get('eform.errors.existing-formName').subscribe((s) => {
         this.existing = s;
      });
      this.translate.get('form-list.header.admin-form-name').subscribe((s)=>{
         this.formNameBtn = s;
      });
   }
}



function compareIds($event: CdkDragDrop<any>): boolean {
   return $event.container.id.substring(6, 7) === $event.previousContainer.id.substring(6, 7);
}

function focusFunc(classes: string) {
   const _input = document.getElementById(classes) as HTMLInputElement;
   _input.focus();
   const val = _input.value;
   _input.value = '';
   _input.value = val;
}
